export const _setReportForm = (state, action) => {
  state.newReportForm = action.payload;
};
